import { render, staticRenderFns } from "./SorryMessage.vue?vue&type=template&id=55d459fa&scoped=true&"
import script from "./SorryMessage.vue?vue&type=script&lang=js&"
export * from "./SorryMessage.vue?vue&type=script&lang=js&"
import style0 from "./SorryMessage.vue?vue&type=style&index=0&id=55d459fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d459fa",
  null
  
)

export default component.exports